const PTTechnology = [
    {
        title: 'Membros dos U2 investem em fundo de tecnologia irlandês. Ronda quer chegar aos 100 milhões de euros',
        description: 'O guitarrista principal da banda musical irlandesa U2, The Edge, e o baixista Clayton, são os mais recentes investidores no fundo detido pela VentureWave Capital, com sede em Dublin, noticia a ‘CNBC’.',
        url: 'https://executivedigest.sapo.pt/membros-dos-u2-investem-em-fundo-de-tecnologia-irlandes-ronda-quer-chegar-aos-100-milhoes-de-euros/',
        image: 'https://executivedigest.sapo.pt/wp-content/uploads/2020/06/u2.jpg',
        publishedAt: "2020-06-27T14:30:00Z",
        source: {
            name: 'Executive Digest',
            url: 'https://executivedigest.sapo.pt'
        }
    },
    {
        title: 'Tecnologia não é a solução mágica para os desafios do sistema educativo',
        description: 'Projetos Expresso. A pandemia veio agravar as desigualdades entre alunos em todos os níveis educativos. O modelo de emergência criado para dar resposta às necessidades de confinamento foi o possível, mas não o perfeito.',
        url: 'https://expresso.pt/economia/2020-06-29-Tecnologia-nao-e-a-solucao-magica-para-os-desafios-do-sistema-educativo',
        image: 'https://images.impresa.pt/expresso/2020-06-29-FOTO_01.jpg/original/mw-860',
        publishedAt: "2020-06-21T17:20:00Z",
        source: {
            name: 'Expresso',
            url: 'https://expresso.pt'
        }
    },
    {
        title: 'Auchan passa a utilizar tecnologia blockchain nos produtos alimentares em Portugal',
        description: 'A Auchan Retail Portugal colocou à venda, em todas as lojas do grupo, os primeiros produtos alimentares em Portugal com recurso à tecnologia blockchain, nomeadamente a alface, o melão e a melancia.',
        url: 'https://www.distribuicaohoje.com/destaques/auchan-passa-a-utilizar-tecnologia-blockchain-nos-produtos-alimentares-em-portugal/',
        image: 'https://www.distribuicaohoje.com/wp-content/uploads/sites/2/2020/06/blockchain_auchan.jpg.webp',
        publishedAt: "2020-06-26T17:50:00Z",
        source: {
            name: 'Distribuição Hoje',
            url: 'https://www.distribuicaohoje.com'
        }
    },
    {
        title: 'Santander acelera transformação digital e contrata em Portugal 100 profissionais de tecnologia este ano',
        description: 'O Banco Santander vai contratar em Portugal, ainda este ano, 100 profissionais com perfil tecnológico para acelerar a sua transformação comercial, tecnológica e digital.',
        url: 'https://www.noticiasdecoimbra.pt/santander-acelera-transformacao-digital-e-contrata-em-portugal-100-profissionais-de-tecnologia-este-ano/',
        image: 'https://www.noticiasdecoimbra.pt/wp-content/uploads/2019/10/santander.jpeg?x75216',
        publishedAt: "2020-06-25T10:30:00Z",
        source: {
            name: 'Notícias de Coimbra',
            url: 'https://www.noticiasdecoimbra.pt'
        }
    },
    {
        title: 'Tecnologia da empresa portuguesa OutSystems já é ensinada em mais de 60 universidades em todo o mundo',
        description: 'Os números são do programa de educação da tecnológica nacional, que prevê ainda quadruplicar protocolos com universidades até ao final deste ano.',
        url: 'https://tek.sapo.pt/noticias/negocios/artigos/tecnologia-da-empresa-portuguesa-outsystems-ja-e-ensinada-em-mais-de-60-universidades-em-todo-o-mundo',
        image: 'https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=NGFmdfW5jZFiIBPsgz06rqwi7+EhlayTTiLik7NDs+PLQ7W0r6lQ3Ll7ZOgDvEXITW34MEU1JSozOpRG+p9AF9g72nHtWFZ/5c5tMdSus+a/Nh4=',
        publishedAt: "2020-06-24T17:10:00Z",
        source: {
            name: 'Sapo Tek',
            url: 'https://tek.sapo.pt'
        }
    },
    {
        title: 'Outfit cresce para 17 países com tecnologia portuguesa da Outsystems',
        description: 'O ambicioso plano de expansão, revelado à imprensa esta terça-feira, tem o horizonte de dois anos, sendo objetivo do grupo Devoteam, que a Outfit integra, tornar-se no líder de ‘low-code’ e parceiro número um da OutSystems na Europa.',
        url: 'https://jornaleconomico.sapo.pt/noticias/outfit-cresce-para-17-paises-com-tecnologia-portuguesa-da-outsystems-601633',
        image: 'https://jornaleconomico.sapo.pt/wp-content/uploads/2020/06/Jo%C3%A3o-Caldas-Outfit-2.jpg?w=730&h=456&q=60&compress=auto,format&fit=crop',
        publishedAt: "2020-06-26T18:40:00Z",
        source: {
            name: 'Jornal Económico',
            url: 'https://jornaleconomico.sapo.pt'
        }
    },
    {
        title: 'Vamos ter novos satélites no espaço. E um deles tem tecnologia portuguesa',
        description: 'Entre meia centena de satélites que a ESA se prepara para lançar, o eSail contou com a participação de duas empresas portuguesas, a Edisoft e a Evoleo.',
        url: 'https://expresso.pt/internacional/2020-06-21-Vamos-ter-novos-satelites-no-espaco.-E-um-deles-tem-tecnologia-portuguesa',
        image: 'https://images.impresa.pt/expresso/2020-06-21-Artist_s_view_of_Vega_VV16_with_SSMS.jpg/original/mw-860',
        publishedAt: "2020-06-29T10:20:00Z",
        source: {
            name: 'Expresso',
            url: 'https://expresso.pt'
        }
    },
    {
        title: 'CBI investe em tecnologia Gerber para EPIs',
        description: 'O grupo português adquiriu recentemente uma máquina de corte Gerber Paragon para aumentar a produção em 50%. Atualmente, o CBI já produz diariamente cerca de 20 mil unidades de equipamentos de proteção individual, nomeadamente batas e máscaras.',
        url: 'https://www.portugaltextil.com/cbi-investe-em-tecnologia-gerber-para-epis/',
        image: 'https://www.portugaltextil.com/wp-content/uploads/2020/06/Gerber_26junho2020_CBI.jpg',
        publishedAt: "2020-06-26T11:20:00Z",
        source: {
            name: 'Portugal Têxtil',
            url: 'https://www.portugaltextil.com'
        }
    },
    {
        title: 'OPPO está com tudo e consegue preciosa parceria com Vodafone Portugal que nos traz OPPO Find X2 Lite e o OPPO A72',
        description: 'O OPPO Find X2 Lite possui tecnologia 5G e as mais recentes funcionalidades de câmara, design, bateria e processador O OPPO A72 oferece a tecnologia mais avançada para uso diário a um preço acessível.',
        url: 'https://androidgeek.pt/a-oppo-chega-a-vodafone-portugal-com-o-oppo-find-x2-lite-e-o-oppo-a72',
        image: 'https://i1.wp.com/androidgeek.pt/wp-content/uploads/2020/06/analise-oppo-find-x2-lite-super-camaras-5g-e-performance-de-topo-e-lite-em-que-androidgeek-2020-06-02_15-04-20_503461.jpg?w=2024&ssl=1',
        publishedAt: "2020-06-28T13:50:00Z",
        source: {
            name: 'Android Geek',
            url: 'https://androidgeek.pt'
        }
    },
    {
        title: 'Tecnologia Portuguesa na luta contra a COVID-19',
        description: 'A Zarph, empresa especializada em Sistemas de Pagamentos e Depósito, lança campanha promoção de equipamentos self-service que ajudam a manter a distância social entre o Operador e o Cliente, eliminando contacto na troca de numerário em processos de pagamento em loja.',
        url: 'http://smart-cities.pt/smn/zarph-tecnologia-pagamento0206/',
        image: 'http://smart-cities.pt/wp-content/uploads/2020/06/TheCreator4ZARPH_Covid19-6-C%C3%B3pia-min-1280x640.jpg',
        publishedAt: "2020-06-27T11:40:00Z",
        source: {
            name: 'Smart Cities',
            url: 'http://smart-cities.pt'
        }
    },
    {
        title: 'Inditex combate pandemia com tecnologia',
        description: 'O grupo fundado por Amancio Ortega registou uma perda de 44% das vendas no primeiro trimestre de 2020 face ao ano passado. As vendas online, contudo, prosperaram, e o plano da Inditex até 2022 prevê um forte investimento em tecnologia.',
        url: 'https://www.portugaltextil.com/inditex-combate-pandemia-com-tecnologia/',
        image: 'https://www.portugaltextil.com/wp-content/uploads/2020/06/Inditex_22junho2020.jpg',
        publishedAt: "2020-06-24T14:40:00Z",
        source: {
            name: 'Portugal Têxtil',
            url: 'https://www.portugaltextil.com'
        }
    },
    {
        title: 'Politécnico de Leiria integra projeto internacional que apoia a transformação digital das empresas',
        description: 'Chama-se GAMELabsNet e conta com seis laboratórios para cumprir com a sua missão. Em Portugal, o Politécnico de Leiria vai criar um laboratório na área da tecnologia industrial.',
        url: 'https://tek.sapo.pt/expert/artigos/politecnico-de-leiria-integra-projeto-internacional-que-apoia-a-transformacao-digital-das-empresas',
        image: 'https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=M2YxSilYk6GsTxRKgeBxXmQCY5X4nu2dVFQJABK9THa6B5PCugc/0+MZoRvkOEDnzSlpzQkcsXUbOuOzuXERGohswiEQ6NGySa8+wIikmMJrKn4=',
        publishedAt: "2020-06-21T11:50:00Z",
        source: {
            name: 'Sapo Tek',
            url: 'https://tek.sapo.pt'
        }
    },
    {
        title: 'Fraunhofer Portugal desenvolve aplicação para prevenção de pragas nas vinhas',
        description: 'O projeto EyesOnTrap está a ser desenvolvido no centro de investigação Fraunhofer AICOS e pretende usar várias tecnologias para prevenir pragas nas vinhas e diminuir o erro humano.',
        url: 'https://visao.sapo.pt/exameinformatica/noticias-ei/ciencia-ei/2020-06-29-fraunhofer-portugal-aplicacao-inteligencia-artificial-pragas-vinhas/',
        image: 'https://images.trustinnews.pt/uploads/sites/5/2019/10/vindimas-o-que-esperar-depois-de-um-ano-atipico-2.jpg',
        publishedAt: "2020-06-29T16:20:00Z",
        source: {
            name: 'Exame Informática',
            url: 'https://visao.sapo.pt/exameinformatica/'
        }
    },
    {
        title: 'Redmi 9 já está disponível na Mi Store em Portugal',
        description: 'A Mi Store anunciou hoje a disponibilidade do Redmi 9 nas lojas físicas e online. O novo modelo, sucessor da linha Redmi 8, apresenta características melhoradas e um design mais actual.',
        url: 'https://noticiasetecnologia.com/redmi-9-disponivel-mi-store-portugal/',
        image: 'https://i0.wp.com/noticiasetecnologia.com/wp-content/uploads/2020/06/Redmi-9-1.jpg?resize=720%2C502&ssl=1',
        publishedAt: "2020-06-29T19:40:00Z",
        source: {
            name: 'Notícias e Tecnologia',
            url: 'https://noticiasetecnologia.com'
        }
    },
    {
        title: 'Sony Portugal inicia uma campanha promocional de Verão',
        description: 'Relaxe e compre on-line com a campanha promocional ‘Sony Special Season’, da Sony Portugal, quer deseje renovar a sua televisão para poder assistir com qualidade aos jogos de futebol, ou se estiver interessado numa nova câmara depois de reacender o seu amor pela fotografia.',
        url: 'https://noticiasetecnologia.com/sony-portugal-campanha-promocional-verao/',
        image: 'https://i0.wp.com/noticiasetecnologia.com/wp-content/uploads/2020/06/Sony-Special-Season.jpg?resize=850%2C457&ssl=1',
        publishedAt: "2020-06-24T17:20:00Z",
        source: {
            name: 'Notícias e Tecnologia',
            url: 'https://noticiasetecnologia.com'
        }
    },
    {
        title: 'Três projetos portugueses de saúde garantem apoio do Instituto Europeu de Inovação e Tecnologia',
        description: 'Um dos projetos usa a câmara do smartphone para monitorizar a pressão arterial através do processamento avançado de imagens. Todas as ideias agora selecionadas ficam concluídas até ao final de 2020.',
        url: 'https://visao.sapo.pt/exameinformatica/noticias-ei/ciencia-ei/2020-06-22-tres-projetos-portugueses-de-saude-garantem-apoio-do-instituto-europeu-de-inovacao-e-tecnologia/',
        image: 'https://images.trustinnews.pt/uploads/sites/5/2020/06/eit-health-1-1440x1080.jpg',
        publishedAt: "2020-06-29T17:50:00Z",
        source: {
            name: 'Exame Informática',
            url: 'https://visao.sapo.pt/exameinformatica/'
        }
    },
    {
        title: '75% dos jovens portugueses criou o primeiro perfil nas redes sociais com menos de 16 anos',
        description: 'Nesta semana em que se celebra o Dia Mundial das Redes Sociais, a WIKO quis perceber a forma como os jovens portugueses utilizam as redes sociais e para que recorrem às mesmas, maioritariamente.',
        url: 'https://www.maistecnologia.com/75-dos-jovens-portugueses-criou-o-primeiro-perfil-nas-redes-sociais-com-menos-de-16-anos/',
        image: 'https://www.maistecnologia.com/wp-content/uploads/2020/06/maistecnologia.com-7-1536x1025.jpg',
        publishedAt: "2020-06-28T18:20:00Z",
        source: {
            name: 'MaisTecnologia',
            url: 'https://www.maistecnologia.com'
        }
    },
    {
        title: 'A tecnologia DS que pode salvar vidas',
        description: 'O inovador sistema DS DRIVER ATTENTION MONITORING combina as câmaras de infravermelhos que estão orientadas para o condutor com o controlo do posicionamento do veículo na estrada, de modo a garantir que quem está ao volante permaneça alerta.',
        url: 'https://automonitor.sapo.pt/2020/06/26/novidades/noticias/a-tecnologia-ds-que-pode-salvar-vidas/',
        image: 'https://automonitor.sapo.pt/wp-content/uploads/2020/06/ds-driver-attention-monitoring_4-750x430.jpg',
        publishedAt: "2020-06-27T11:30:00Z",
        source: {
            name: 'AutoMonitor',
            url: 'https://automonitor.sapo.pt'
        }
    },
    {
        title: 'everis Awards: 70 mil euros para premiar projeto de base tecnológica',
        description: 'Economia digital, tecnologias setoriais e biotecnologia e saúde são as 3 categorias a concurso nos everis Awards, que vai já na sua 19.ª edição. As candidaturas decorrem até ao dia 21 de junho de 2020.',
        url: 'https://observador.pt/2020/06/05/everis-awards-70-mil-euros-para-premiar-projeto-de-base-tecnologica/',
        image: 'https://bordalo.observador.pt/900x,q85/https://s3.observador.pt/wp-content/uploads/2020/06/04145819/istock-1066165584_770x433_acf_cropped.jpg',
        publishedAt: "2020-06-26T17:20:00Z",
        source: {
            name: 'Observador',
            url: 'https://observador.pt'
        }
    },
    {
        title: 'Maior competição de apps de jovens arranca em Valongo e Oeiras',
        description: 'Está de volta a maior competição nacional de aplicações criada por jovens, na qual 90 equipas vão fazer o pitch, expor as suas aplicações. Com o objetivo de incentivar os jovens a usar a tecnologia para resolver problemas relacionados com a sustentabilidade do mundo, o programa educativo Apps for Good arranca em Valongo e Oeiras.',
        url: 'https://www.dinheirovivo.pt/tecnologia/maior-competicao-de-apps-de-jovens-arranca-em-valongo-e-oeiras/',
        image: 'https://www.dinheirovivo.pt/wp-content/uploads/2019/07/35101818_GI02072019FILIPEAMORIM0631_WEB-1060x594.jpg',
        publishedAt: "2020-06-29T11:10:00Z",
        source: {
            name: 'Dinheiro Vivo',
            url: 'https://www.dinheirovivo.pt'
        }
    }
]

export default PTTechnology;